import eventBus from '@/events/eventBus'

export * from '~/sites/oknanebodvere/store/user'

import { actions as parentActions } from '~/sites/oknanebodvere/store/user'
import eventDefinitions from '@/events/eventDefinitions'

export const actions = {
  ...parentActions,
  async FETCH_USER({ commit, state, dispatch }, { forceReload = false }) {
    if (!state.isLoaded || forceReload) {
      commit('SET_LOADING', true)
      try {
        const response = await this.$axios.$get(this.$env.STORE_URL + '/api/v1/user', {})
        commit('SET_USER_DATA', response.data)
        await dispatch('auth/SET_VARIANT', state.userData.variantHash, { root: true })
        await dispatch('auth/SET_USER_GROUPS', state.userData.groups, { root: true })
        dispatch('FETCH_WISHLIST')
        dispatch('FETCH_USER_SHOPPING_LISTS')
      } catch (e) {
        if (e.response && e.response.status === 401) {
          dispatch('auth/REMOVE_AUTH', null, { root: true })
          dispatch('auth/SET_AXIOS_TOKEN', null, { root: true })
        } else {
          console.error(e)
        }
      }
      commit('SET_LOADING', false)
    }
  },
  async REGISTER({ commit, dispatch }, data) {
    try {
      const response = await this.$axios.$post(this.$env.STORE_URL + '/api/v1/register', data)
      eventBus.$emit(eventDefinitions.USER.REGISTERED, { user: response.data })

      if (data.newsletter && response.data.newsletter) {
        eventBus.$emit(eventDefinitions.NEWSLETTER.SUBSCRIBED, { user: response.data })
      }

      return response
    } catch (e) {
      return e.response
    }
  },
  async UPDATE_USER({ commit, dispatch }, data) {
    try {
      const response = await this.$axios.$patch(this.$env.STORE_URL + '/api/v1/user', data)
      commit('SET_USER_DATA', response.data)

      if (data.newsletter && response.data.newsletter) {
        eventBus.$emit(eventDefinitions.NEWSLETTER.SUBSCRIBED, { user: response.data })
      }

      return response
    } catch (e) {
      return e.response
    }
  },
}
